module.exports = "<div>\r\n    {{texto_mostrar}} \r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/DescargaApp/DescargaApp.component.html
// module id = ../../../../../src/app/views/DescargaApp/DescargaApp.component.html
// module chunks = main